import sprayApi from '../api/sprayApi'
import sprayRepo from '../repos/sprayRepo'

export default {
    async fetchAndStoreMasterData() {
        // Try and fetch from server
        let masterData = await sprayApi.getSprayMasterData();

        // Clear table
        await sprayRepo.clearMasterData();
        if(masterData) {
            await sprayRepo.addMasterData({masterData});
        }
    },
    async addSpray(spray) {
        await sprayRepo.addUnAddSpray(spray);
        return await this.postUnSyncedData();

    },
    async updateSpray(spray) {
        await sprayRepo.addUnUpdateSpray(spray);
        return await this.postUnSyncedData();

    },
    async deleteSpray(spray) {
        await sprayRepo.addUnDeleteSprayID(spray);
        return await this.postUnSyncedData();
    },
    async postUnSyncedData() {
        let unAddSpraies = await sprayRepo.getUnAddSpraies();
        let unUpdateSpraies = await sprayRepo.getUnUpdateSpraies();
        let unDeleteSprayIDs = await sprayRepo.getUnDeleteSprayIDs();

        await sprayApi.batchProcessUnSyncedSpraies({UnAddSpraies: unAddSpraies, UnUpdateSpraies: unUpdateSpraies, UnDeleteSprayIDs: unDeleteSprayIDs.map(s=> s.SprayID)});

        await sprayRepo.clearUnAddSpraies();
        await sprayRepo.clearUnUpdateSpraies();
        await sprayRepo.clearUnDeleteSprayIDs();

    },
    async getTotalUnSyncedSpraies() {
        var unAddSpraies = await sprayRepo.getUnAddSpraies();
        var unUpdateSpraies = await sprayRepo.getUnUpdateSpraies();
        var unDeleteSprayIDs = await sprayRepo.getUnDeleteSprayIDs();
        return {
            unAddSpraies: unAddSpraies.length,
            unUpdateSpraies: unUpdateSpraies.length,
            unDeleteSpraies: unDeleteSprayIDs.length
        }
    }
    
}

